<template>
    <div class="container-xs">
        <div class="case-creation__step case-creation__patient-information">
            <div class="case-creation__card mb-10">
                <div class="case-creation__heading">
                    <div class="title-with-icon">
                        <span class="icon">
                            <img src="@/assets/images/icons/icon-patient-info.svg" alt="icon" class="img-fluid" />
                        </span>
                        <h3 class="title">Add Rule</h3>
                    </div>
                </div>
                <div class="case-creation__body pb-0">
                    <div class="vue-form">
                        <el-form :model="ruleData">
                            <el-row :gutter="30">
                                <el-col :span="24">
                                    <div class="case-creation__input">
                                        <el-form-item class="mb-15 ">
                                            <label for="text" style="display: block; margin-bottom: 6px;">
                                                Rule Description <span class="star">*</span>
                                            </label>
                                            <el-input type="textarea" placeholder="Enter Rule Description"
                                                v-model="ruleData.rule_description" :rows="4" resize="none"></el-input>
                                            <p class="err error-break">
                                                <FormError errorName="rule_description" />
                                            </p>
                                        </el-form-item>
                                    </div>
                                </el-col>
                            </el-row>

                            <el-row :gutter="30">
                                <el-col :span="8">
                                    <div class="case-creation__input">
                                        <el-form-item class="mb-15">
                                            <label for="text"> Payers </label>
                                            <el-input placeholder="Enter Payers" v-model="ruleData.payers"></el-input>
                                            <p class="err error-break">
                                                <FormError errorName="payers" />
                                            </p>
                                        </el-form-item>
                                    </div>
                                </el-col>

                                <el-col :span="8">
                                    <div class="case-creation__input">
                                        <el-form-item class="mb-15">
                                            <label for="text"> Source <span class="star">*</span></label>
                                            <el-input placeholder="Enter Source" v-model="ruleData.source"></el-input>
                                            <p class="err error-break">
                                                <FormError errorName="source" />
                                            </p>
                                        </el-form-item>
                                    </div>
                                </el-col>

                                <el-col :span="8">
                                    <div class="case-creation__input">
                                        <el-form-item class="mb-15">
                                            <label for="text"> Category <span class="star">*</span></label>
                                            <el-select v-model="ruleData.category" filterable
                                                placeholder="Select Category">
                                                <el-option v-for="(rule, index) in billingRuleBookList" :key="index"
                                                    :label="rule.label" :value="rule.label" />
                                            </el-select>
                                            <p class="err error-break">
                                                <FormError errorName="category" />
                                            </p>
                                        </el-form-item>
                                    </div>
                                </el-col>
                            </el-row>

                            <el-row :gutter="30">
                                <el-col :span="8">
                                    <div class="case-creation__input">
                                        <el-form-item class="mb-15">
                                            <label for="caseTypes">Case Types</label>
                                            <el-select v-model="ruleData.case_types" multiple filterable
                                                placeholder="Select Case Types" :multiple-limit="getCaseTypeLimit"
                                                @change="handleCaseTypeChange" collapse-tags collapse-tags-tooltip>
                                                <el-option v-for="(caseType, index) in caseTypesList" :key="index"
                                                    :value="caseType.label" :label="caseType.label" />
                                            </el-select>
                                            <p class="err error-break">
                                                <FormError errorName="case_types" />
                                            </p>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="case-creation__input">
                                        <el-form-item class="mb-15">
                                            <label for="text"> Start Date <span class="star">*</span></label>
                                            <el-date-picker type="date" v-model="ruleData.rule_start_date"
                                                placeholder="Select Start Date" format="MM-DD-YYYY"
                                                value-format="YYYY-MM-DD"
                                                :disabled-date="disabledDate"></el-date-picker>
                                            <p class="err error-break">
                                                <FormError errorName="rule_start_date" />
                                            </p>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="case-creation__input">
                                        <el-form-item class="mb-15">
                                            <label for="text"> End Date <span class="star">*</span></label>
                                            <el-date-picker type="date" v-model="ruleData.rule_end_date"
                                                placeholder="Select End Date" format="MM-DD-YYYY"
                                                value-format="YYYY-MM-DD"></el-date-picker>
                                            <p class="err error-break">
                                                <FormError errorName="rule_end_date" />
                                            </p>
                                        </el-form-item>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="case-creation__actions">
                        <ul class="list pt-0">
                            <li>
                                <el-button size="medium" type="default" class="btn cancel-button"
                                    @click="goBack">Cancel</el-button>
                            </li>
                            <li>
                                <el-button v-if="this.$route.params.rule_id" size="medium" type="success"
                                    class="btn save-button" @click="updateRuleDetails()"
                                    :loading="submitLoading">Update</el-button>
                                <el-button v-else size="medium" type="success" class="btn save-button"
                                    @click="submitRulesDetails()" :loading="submitLoading">Save</el-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    successNotification,
    errorNotification,
} from "@/helpers/notifications";
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import { defineAsyncComponent } from "vue";

const FormError = defineAsyncComponent(() =>
    import("@/components/misc/FormError")
);
export default {
    components: {
        FormError,
    },
    data() {
        return {
            submitLoading: false,
            ruleData: {
                rule_description: "",
                category: "",
                case_types: "",
                payers: "",
                rule_start_date: null,
                rule_end_date: null,
                source: "",
                status: "ACTIVE"
            },
            billingRuleBookList: caseConstants.billingRuleBook,
            caseTypesList: caseConstants.CASE_TYPES_DATA,
            disabledDate: (time) => {
                return time.getTime() > Date.now();
            },
            disablePastDates(date) {
                return date.getTime() < new Date().setHours(0, 0, 0, 0);
            }
        };

    },
    computed: {
        ...mapGetters("rulebook", [
            "getRuleCreationStatus",
            "getRuleDetails",
            "getRuleUpdateStatus"
        ]),
        ...mapGetters("errors", ["getErrors", "getError"]),
    },
    mounted() {
        if (this.$route.params.rule_id) {
            this.fetchRuleById(this.$route.params.rule_id);
        }
    },
    methods: {
        async updateRuleDetails() {
            try {

                await this.$store.dispatch("rulebook/updateRule", {
                    ruleData: {
                        ...this.ruleData,
                        _id: this.$route.params.rule_id
                    }
                });
                if (this.getRuleUpdateStatus) {
                    successNotification("Rule updated successfully");
                    this.cancelRule();
                    this.ruleData = {};
                } else {
                    if (!this.getErrors || this.getError) {
                        errorNotification(this.getError || "Error while updating Rule");
                    }
                }
            } catch (err) {
                console.log(err);
            }
        },
        async fetchRuleById(ruleId) {
            await this.$store.dispatch("rulebook/getRuleById", ruleId);

            if (this.getRuleDetails && this.getRuleDetails.data) {
                const data = this.getRuleDetails.data;

                this.ruleData = {
                    rule_description: data.rule_description || "",
                    category: data.category || "",
                    case_types: Array.isArray(data.case_types)
                        ? data.case_types
                        : data.case_types?.split(",") || [],
                    payers: data.payers || "",
                    source: data.source || "",
                    rule_start_date: data.rule_start_date || null,
                    rule_end_date: data.rule_end_date || null,
                    status: data.status || "ACTIVE"
                };
            }
        },

        async submitRulesDetails() {
            try {
                const payload = { ...this.ruleData };

                // Remove null or empty fields (especially dates)
                Object.keys(payload).forEach((key) => {
                    if (
                        payload[key] === null ||
                        payload[key] === undefined ||
                        (Array.isArray(payload[key]) && payload[key].length === 0) ||
                        (typeof payload[key] === 'string' && payload[key].trim() === '')
                    ) {
                        delete payload[key];
                    }
                });

                // Dispatch the sanitized payload
                await this.$store.dispatch("rulebook/createRule", payload);

                if (this.getRuleCreationStatus) {
                    successNotification("Rule added successfully");
                    this.cancelRule()
                    this.ruleData = {};
                } else {
                    if (!this.getErrors || this.getError) {
                        errorNotification(this.getError || "Error while adding Rule");
                    }
                }
            } catch (err) {
                console.log(err);
            }
        },
        async cancelRule() {

            const categoryRouteMap = {
                "Coding Rule Book": "AllCodingRules",
                "Claim Processing": "AllClaim",
                "AR Rule Book": "AllARRules",
                "Payment Posting Rule Book": "PaymentRules",
                "Patient Statement Rule Book": "PateintRules",
            };

            const targetRoute =
                categoryRouteMap[this.ruleData.category] || "AllCodingRules";

            this.$router.push({
                name: targetRoute,
            });
        },
        goBack() {
            if (Object.keys(this.ruleData).length === 0) {
                this.clearDataAndGoToInsurances();
            } else {
                this.$confirm(
                    `Are you sure to cancel ${this.$route.params.insurance_id ? "updating" : "adding new"} Rule?`,
                    "Warning",
                    {
                        confirmButtonText: "OK",
                        cancelButtonText: "Cancel",
                        type: "warning",
                    }
                ).then(() => {
                    this.cancelRule();
                });
            }
        },
        clearDataAndGoToInsurances() {
            this.ruleData = {};
            this.goToInsurances();
        },
        goToInsurances() {
            this.$router.push({ name: "AllInsurances" });
        },
    },
};
</script>
<style scoped>
.full-width-item {
  width: 900px;
}
</style>
